export default "__VITE_ASSET__DrjfKoAm__"